/**
 * AttributionBadge — Icon-only indicator for transaction categorization source
 *
 * Sparkle (✦) = AI categorized. Checkmark (✓) = user confirmed.
 * No text, no percentages. Detail sheet shows full reasoning on tap.
 */

import { Sparkle, Check } from 'lucide-react';
import { T } from '@/styles/tokens';

interface AttributionBadgeProps {
  /** 'ai' | 'user' | 'rule' — source of the categorization */
  confirmedBy?: string | null;
}

export function AttributionBadge({ confirmedBy }: AttributionBadgeProps) {
  if (confirmedBy === 'user') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
        <Check size={12} strokeWidth={2.5} color={T.textMuted} />
      </span>
    );
  }

  // Default: AI categorized (includes 'ai', 'rule', or null)
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
      <Sparkle size={12} strokeWidth={2} color={T.textMuted} />
    </span>
  );
}
